/**
 * Elevate storefront → Sky High checkout.
 * Same SKUs. Browse here, pay on Sky High.
 *
 * Handoff URL is cart/clear?return_to=/cart/ID:QTY (not /cart/ID:QTY?note=…).
 * Direct permalinks 404 as "Link no longer exists" when SH variant IDs
 * stale, and leftover SH cart cookies poison the next jump.
 */
(function () {
  var SH = "https://www.fly-with-sky-high.com";
  var MAP_URL = window.ELEVATE_SH_SKU_MAP_URL;
  if (!MAP_URL) return;

  var mapPromise = null;
  function loadMap() {
    if (!mapPromise) {
      mapPromise = fetch(MAP_URL, { credentials: "omit", cache: "no-store" }).then(
        function (r) {
          if (!r.ok) throw new Error("sku map " + r.status);
          return r.json();
        },
      );
    }
    return mapPromise;
  }

  function lookup(map, item) {
    var sku = String(item.sku || "").trim();
    var barcode = String(item.barcode || "").trim();
    var handle = String(item.handle || "").trim();
    var vtitle = String(item.variant_title || "").trim();
    if (sku && map.bySku && map.bySku[sku]) return map.bySku[sku];
    if (barcode && map.byBarcode && map.byBarcode[barcode]) return map.byBarcode[barcode];
    if (handle && map.byHandle) {
      var keyed = handle + "::" + vtitle;
      if (map.byHandle[keyed]) return map.byHandle[keyed];
      if (map.byHandle[handle]) return map.byHandle[handle];
    }
    return null;
  }

  function buildUrl(matched) {
    var pairs = matched
      .map(function (m) {
        return m.id + ":" + m.qty;
      })
      .join(",");
    return SH + "/cart/clear?return_to=" + encodeURIComponent("/cart/" + pairs);
  }

  function showTransfer(missing, onContinue) {
    var existing = document.getElementById("elevate-transfer-screen");
    if (existing) existing.remove();
    var wrap = document.createElement("div");
    wrap.id = "elevate-transfer-screen";
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("aria-labelledby", "elevate-transfer-title");
    wrap.innerHTML =
      '<div class="elevate-transfer__scrim"></div>' +
      '<div class="elevate-transfer__card">' +
      '<p class="elevate-transfer__kicker">Secure checkout</p>' +
      '<h2 id="elevate-transfer-title">We\'re transferring you to our local partner to process your order.</h2>' +
      "<p>Sky High will take payment for the same items. You can still pick up at Elevate or have the order shipped.</p>" +
      (missing && missing.length
        ? "<p class=\"elevate-transfer__miss\">These items aren’t available for online checkout yet and won’t be included: " +
          missing.join(", ") +
          ".</p>"
        : "") +
      '<button type="button" class="button elevate-transfer__go">Continue to Sky High</button>' +
      '<button type="button" class="elevate-transfer__stay">Go back</button>' +
      "</div>";
    var style = document.createElement("style");
    style.textContent =
      "#elevate-transfer-screen{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:1.25rem;font-family:inherit;}" +
      "#elevate-transfer-screen .elevate-transfer__scrim{position:absolute;inset:0;background:rgba(22,28,32,.55);backdrop-filter:blur(4px);}" +
      "#elevate-transfer-screen .elevate-transfer__card{position:relative;max-width:26.5rem;width:100%;background:#fff;color:#1c1c1c;padding:1.75rem 1.6rem 1.4rem;border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,.22);font-size:1rem;line-height:1.55;}" +
      "#elevate-transfer-screen h2{margin:.15rem 0 .75rem;font-size:1.28rem;line-height:1.3;font-weight:600;letter-spacing:-.01em;}" +
      "#elevate-transfer-screen p{margin:0 0 .65rem;}" +
      "#elevate-transfer-screen .elevate-transfer__kicker{margin:0 0 .4rem;letter-spacing:.12em;text-transform:uppercase;font-size:.68rem;font-weight:600;color:#5a6570;}" +
      "#elevate-transfer-screen .elevate-transfer__miss{font-size:.9rem;color:#5a6570;}" +
      "#elevate-transfer-screen .elevate-transfer__go{width:100%;margin-top:.85rem;}" +
      "#elevate-transfer-screen .elevate-transfer__stay{display:block;width:100%;margin-top:.45rem;background:none;border:0;padding:.55rem;font:inherit;color:#5a6570;cursor:pointer;}";
    document.head.appendChild(style);
    document.body.appendChild(wrap);
    document.documentElement.style.overflow = "hidden";
    function close() {
      wrap.remove();
      document.documentElement.style.overflow = "";
    }
    var go = wrap.querySelector(".elevate-transfer__go");
    if (typeof onContinue === "function") {
      go.addEventListener("click", function () {
        onContinue();
      });
      go.focus();
    } else {
      go.style.display = "none";
    }
    wrap.querySelector(".elevate-transfer__stay").addEventListener("click", close);
  }

  function route(ev) {
    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    }
    Promise.all([
      loadMap(),
      fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then(function (r) {
        return r.json();
      }),
    ])
      .then(function (pair) {
        var map = pair[0];
        var cart = pair[1];
        var items = cart.items || [];
        if (!items.length) {
          window.location.href = "/cart";
          return;
        }
        var matched = [];
        var missing = [];
        items.forEach(function (item) {
          var hit = lookup(map, item);
          var title = item.product_title || item.title || item.sku || "item";
          var want = item.quantity || 1;
          if (!hit || !hit.id) {
            missing.push(title);
            return;
          }
          var cap = hit.maxQty;
          var qty = want;
          if (typeof cap === "number") {
            if (cap <= 0) {
              missing.push(title);
              return;
            }
            if (qty > cap) {
              missing.push(title + " (only " + cap + " available online)");
              qty = cap;
            }
          }
          matched.push({ id: String(hit.id), qty: qty, title: title });
        });
        if (!matched.length) {
          showTransfer(missing.length ? missing : ["No matching Sky High items"], null);
          return;
        }
        showTransfer(missing, function () {
          window.location.assign(buildUrl(matched));
        });
      })
      .catch(function () {
        mapPromise = null;
        showTransfer(["Checkout map failed to load — tap continue to retry"], function () {
          route(null);
        });
      });
    return false;
  }

  function isCheckoutControl(el) {
    if (!el || !el.closest) return false;
    if (el.closest && el.closest("shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .additional-checkout-buttons")) {
      return true;
    }
    var btn = el.closest('button, input[type="submit"], a, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (!btn) return false;
    if (btn.name === "checkout") return true;
    if (btn.id === "checkout" || btn.id === "CartDrawer-Checkout") return true;
    if (btn.classList && btn.classList.contains("cart__checkout-button")) return true;
    var href = (btn.getAttribute && btn.getAttribute("href")) || "";
    if (/\/checkout(\?|$)/.test(href)) return true;
    var action = (btn.getAttribute && btn.getAttribute("formaction")) || "";
    if (/\/checkout(\?|$)/.test(action)) return true;
    return false;
  }

  document.addEventListener(
    "click",
    function (ev) {
      if (isCheckoutControl(ev.target)) route(ev);
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (ev) {
      var form = ev.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || form.action || "";
      var submitter = ev.submitter;
      if (submitter && (submitter.name === "checkout" || isCheckoutControl(submitter))) {
        route(ev);
        return;
      }
      if (
        form.id === "cart" ||
        form.id === "CartDrawer-Form" ||
        form.id === "cart-notification-form" ||
        /\/cart(\?|$)/.test(action) ||
        /\/checkout(\?|$)/.test(action)
      ) {
        if (submitter && submitter.name === "checkout") route(ev);
      }
    },
    true,
  );

  window.elevatePayOnSkyHigh = route;
})();
